module.exports = __webpack_public_path__ + "static/media/deudas-8.7c652482.png";